var listFadeStartGradient = 'rgba(0, 0, 0, 0) 8px, rgba(0, 0, 0, 1) 60px';
var listFadeEndGradient = 'rgba(0, 0, 0, 1) calc(100% - 60px), rgba(0, 0, 0, 0) calc(100% - 8px)';
var fadeStartGradient = 'rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 1) 52px';
var fadeEndGradient = 'rgba(0, 0, 0, 1) calc(100% - 52px), rgba(0, 0, 0, 0) 100%';
var fadeOption = function fadeOption(start, end) {
  if (start && end) return 'both';
  if (start) return 'start';
  if (end) return 'end';
  return false;
};
var getFadeGradients = function getFadeGradients(withSpacing, fade, isRtl) {
  var baseGradientDirection = "linear-gradient(".concat(isRtl ? 'to left' : 'to right');
  var startGradient = withSpacing ? fadeStartGradient : listFadeStartGradient;
  var endGradient = withSpacing ? fadeEndGradient : listFadeEndGradient;
  switch (fade) {
    case 'both':
      return "".concat(baseGradientDirection, ", ").concat(startGradient, ", ").concat(endGradient, ")");
    case 'start':
      return "".concat(baseGradientDirection, ", ").concat(startGradient, ")");
    case 'end':
      return "".concat(baseGradientDirection, ", ").concat(endGradient, ")");
    default:
      return undefined;
  }
};

export { fadeOption, getFadeGradients };
//# sourceMappingURL=fadeGradiant.js.map
